import omit from 'lodash/omit';
import React, { useState } from 'react';

import CustomSelect from '../common/CustomSelect';
import { formatProviderName } from '../../helpers/providers';
import { useGetProvidersQuery } from '../../redux/services/providerApi';

const SelectProviderInput = props => {
  // const [search, setSearch] = useState('');
  const searchQuery = useGetProvidersQuery({});
  return (
    <CustomSelect
      defaultValue={props?.defaultValue}
      label={props?.hideLabel ? null : (props?.label || 'Select Provider')}
      disabled={props?.disabled || searchQuery.isLoading}
      options={(searchQuery?.data || []).map(p => ({
        label: formatProviderName(p), 
        value: p.id,
      }))}
      {...omit(props, 'options')}
      onChange={e => {
        // setSearch(e.target.value);
        props.onChange(e, e.target.value);
      }}
    />
  );
};

export default SelectProviderInput;